import React from 'react'
import { Modal } from '..'
import { Button, DialogActions, Wrapper, Title, Description } from './style'

const Confirmation = ({
  title,
  description = null,
  onSubmit,
  open = false,
  submitMsg = 'yes',
  cancelMsg = 'no',
  showCloseButton = false,
  showSubmitMsg = true,
  showCancelMsg = true,
  onClose,
  onCancel,
  ...rest
}) => {
  return (
    <>
      {open && (
        <Modal {...rest} title='' showClose={showCloseButton} onClose={onClose || onCancel} modalClass='confirmationWrapper'>
          <Wrapper>
            <Title id='alert-dialog-title' variant='body1'>
              {title}
            </Title>
            {description && <Description>{description}</Description>}
            <DialogActions>
              {showCancelMsg && (
                <Button variant='contained' onClick={onCancel || onClose} color='gray'>
                  {' '}
                  {cancelMsg}
                </Button>
              )}
              {showSubmitMsg && (
                <Button color='primary' variant='contained' onClick={onSubmit} autoFocus>
                  {submitMsg}
                </Button>
              )}
            </DialogActions>
          </Wrapper>
        </Modal>
      )}
    </>
  )
}

export default Confirmation
